import React, { useEffect, useState } from "react";
import "./Header.css";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`header${scrolled ? " header--scrolled" : ""}`}>
      <div className="container header__inner">
        <a className="header__brand" href="#top">
          <span className="header__mark" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M5 18c0-3 3-3.4 6-4s6-1 6-4a3 3 0 0 0-6 0c0 3 3 4 6 4"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
              <circle cx="5" cy="18" r="2.4" fill="currentColor" />
            </svg>
          </span>
          TravelEase
        </a>

        <nav className="header__nav" aria-label="Primary">
          <a href="#how">How it works</a>
          <a href="#planner">Plan a route</a>
        </nav>

        <div className="header__actions">
          <a
            className="header__link"
            href="https://github.com/SandhuKaran"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
          <a className="btn header__cta" href="#planner">
            Try it
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
